<mat-tab-group>
  <mat-tab label="Elements">
    <stars-lesson-elements></stars-lesson-elements>
  </mat-tab>

  <mat-tab label="Anatomy">
    <stars-lesson-anatomy></stars-lesson-anatomy>
  </mat-tab>
</mat-tab-group>
